import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {RecordlogEvents} from '../../analytics/RecordEvents'
import {GTM_Select_Item}  from "../../../src/analytics//GoogleTagManager";
import { MAKE_NOJOOM_HOT_DELAS_EXCLUSIVE } from '../../services/common/Constants';
import ExclusiveModal from '../common/exclusive-modal';
import useAppExclusive from '../../hooks/useAppExclusive';
const HotDealsCard = ({ data }) => {
  const { t } = useTranslation();
  const {show, toggleModal} = useAppExclusive();

  const handleRedirect = (e) => {
    try{
      GTM_Select_Item(data, "NojoomHotDeals")
    }catch{}
   try{PushCT(data?.displaytext)}catch{}

    e.preventDefault();

    if(MAKE_NOJOOM_HOT_DELAS_EXCLUSIVE){
      toggleModal();
    }else{
      if (data?.redirecturl) {
        const target = data?.external === 'False' ? '_self' : '_blank';
        window.open(data?.redirecturl, target);
      } else {
        return;
      }
    }
  };

const PushCT = (product)=>{
  RecordlogEvents('nojoom hot deals', {
    'Product Viewed': product,
     "category":"Nojoom",
     "subcategory":"Nojoom Hot deals", 
     "product name":product                      
  });
}


  return (
    <>
    <Link className="card_style_1 height_100" to={`#`} onClick={handleRedirect}>
      <div className="card_img">
        <img
          src={
            data?.imageurl ||
            process.env.PUBLIC_URL + '/assets/images/dummy_img.jpg'
          }
          alt=""
          title=""
        />
      </div>
      <div className="card_info text-center">
        <div className="card_info_grp">
          <h4 className="text-ellipsis">{data?.displaytext}</h4>
          <p>{data?.description}</p>
        </div>
        <div className="card_link">
          <Link to="#" className="hyperlink">
            {data?.buttontext}
            <img
              src={
                process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'
              }
              alt=""
              title=""
            />
          </Link>
        </div>
      </div>
    </Link>

    <ExclusiveModal show={show} toggleModal={toggleModal} deeplinktext='nojoom' />
    </>
  );
};
export default HotDealsCard;
